import { useState } from "react";
import { Button } from "react-bootstrap";

const Unanswered = ({ dataUnanswered }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; // Sesuaikan jumlah item per halaman

  // Hitung total halaman
  const totalPages = Math.ceil(dataUnanswered.length / itemsPerPage);

  // Hitung indeks awal dan akhir untuk slicing
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Data yang akan ditampilkan sesuai halaman
  const currentData = dataUnanswered.slice(startIndex, endIndex);

  return (
    <div>
      {currentData.length > 0 ? (
        currentData.map((item, index) => (
          <div key={index} className="card shadow-lg border">
            <div className="card-body">
              <p className="fw-bold fs-14 mb-1">{item.topic_title}</p>
              <p>{item.topic_content}</p>
              <hr />
              <p className="mb-1">
                <b>Frequency:</b>
              </p>
              <p className="mb-1">{item.frequency}</p>
              <p className="mb-1">
                <b>Impact:</b>
              </p>
              <p className="mb-1">{item.impact}</p>
            </div>
          </div>
        ))
      ) : (
        <div className="card shadow-lg border">
          <div className="card-body text-dark">No Data</div>
        </div>
      )}

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-between">
          <div>
            Page {currentPage} of {totalPages}
          </div>
          <div>
            <Button
              variant="dark"
              className="btn btn-sm me-2"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              Prev
            </Button>
            <Button
              variant="dark"
              className="btn btn-sm"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Unanswered;
